<template>
  <div class="calendar-input-container" v-click-outside="onClickOutside">
    <div class="input calendar-input">
      <input
        ref="input"
        type="text"
        class="calendar-input-text no-border"
        :value="textValue"
        @click="openCalendar"
        @keyup.left="subtractDay"
        @keyup.right="addDay"
        @keyup.esc="closeCalendar"
        @keypress.enter.prevent="closeCalendar"
        @focus="openCalendar"
        readonly
      />
      <a class="" @click="openCalendar"><CalendarIcon></CalendarIcon></a>
    </div>
    <div v-if="showCalendar" class="calendar-container">
      <Calendar :value="modelValue" @update:modelValue="onInput" :limitStart="limitStart" :limitEnd="limitEnd"></Calendar>
    </div>
  </div>
</template>

<script>
import CalendarIcon from '../assets/icons/calendar.svg';
import Calendar from './Calendar.vue';
import ClickOutside from '../utils/ClickOutside';
import { format, addDays, subDays, isValid, isAfter, isBefore } from 'date-fns';

export default {
  components: {
    CalendarIcon,
    Calendar,
  },

  props: {
    modelValue: {
      default: null,
      validator: (val) => {
        return !val || isValid(val);
      },
    },
    limitStart: {
      default: null,
      type: [Date, Number],
    },
    limitEnd: {
      default: null,
      type: [Date, Number],
    },
  },

  data() {
    const formattedValue = this.formatValue(this.modelValue);
    return {
      showCalendar: false,
      textValue: formattedValue,
    };
  },

  methods: {
    openCalendar() {
      this.showCalendar = true;
    },

    closeCalendar() {
      this.showCalendar = false;
      this.$refs.input.blur();
    },

    onClickOutside() {
      this.showCalendar = false;
      this.$refs.input.blur();
    },

    onInput(value) {
      this.showCalendar = false;
      this.$emit('update:modelValue', value);
      this.$refs.input.blur();
    },

    focusIn() {
      this.openCalendar();
    },

    formatValue(val) {
      return val && isValid(val) ? format(val, 'yyyy-MM-dd') : '';
    },

    subtractDay() {
      const date = subDays(this.modelValue, 1);
      if (!isBefore(date, this.limitStart)) {
        this.$emit('update:modelValue', date);
      }
    },

    addDay() {
      const date = addDays(this.modelValue, 1);
      if (!isAfter(date, this.limitEnd)) {
        this.$emit('update:modelValue', date);
      }
    },
  },

  watch: {
    modelValue: {
      handler(newValue, oldValue) {
        this.textValue = this.formatValue(newValue);
      },
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/mixins';

.calendar-input-container {
  position: relative;

  .calendar-input.input {
    display: flex;
    align-items: center;
    position: relative;
  }

  .calendar-container {
    @mixin overlay;
    position: absolute;
    left: 0;
    max-width: 320px;
    margin-top: 1px;
    z-index: 1;
  }

  .calendar-input-text {
    min-width: 10px;
    padding-left: 0px;
  }

  @media (max-width: 676px) {
    position: static;

    .calendar-container {
      max-width: 100%;
      width: 100%;
    }
  }
}
</style>
